import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import { useBusinessData } from '../../context/BusinessContext';
import '../../css/Vision.css';

const Vision = () => {
  const { loading, error, getData, hasData, getImageUrl } = useBusinessData();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error loading data: {error}</div>;
  }

  const strategicGoals = getData('vision.strategicGoals', []);
  const futureParagraphs = getData('vision.future.paragraphs', []);
  
  // Get vision hero background image from JSON using getImageUrl
  const visionHeroImage = getImageUrl('images.backgrounds.vision', 'vision-hero.jpg');
  
  // Get future content image
  const futureImage = getImageUrl('images.content.future', 'future-img.jpg');
  
  // Create inline style for background image - using URL directly
  const visionHeroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('${visionHeroImage}')`
  };

  return (
    <>
      {/* Vision Hero */}
      <div className="vision-hero" style={visionHeroStyle}>
        <div className="container">
          <div className="vision-hero-content">
            <h1>{getData('ui.vision.pageTitle', 'Our Vision & Mission')}</h1>
            <p>{getData('ui.vision.pageSubtitle', 'Driving business success through innovation and excellence')}</p>
          </div>
        </div>
      </div>
      
      {/* Vision Statement */}
      <section className="section">
        <div className="container">
          <div className="vision-statement">
            <div className="vision-icon">
              <FontAwesomeIcon icon={solidIcons.faEye} />
            </div>
            <h2>Our Vision</h2>
            <p>{getData('vision.statement', '')}</p>
          </div>
        </div>
      </section>
      
      {/* Mission Statement */}
      <section className="section section-dark">
        <div className="container">
          <div className="mission-statement">
            <div className="mission-icon">
              <FontAwesomeIcon icon={solidIcons.faRocket} />
            </div>
            <h2>Our Mission</h2>
            <p>{getData('vision.mission', '')}</p>
          </div>
        </div>
      </section>
      
      {/* Strategic Goals */}
      {hasData('vision.strategicGoals') && strategicGoals.length > 0 && (
        <section className="section">
          <div className="container">
            <h2 className="section-title">{getData('ui.vision.goalsSection.title', 'Strategic Goals')}</h2>
            <p className="section-subtitle">{getData('ui.vision.goalsSection.subtitle', 'Our long-term objectives that guide our business operations and growth.')}</p>
            
            <div className="goals-grid">
              {strategicGoals.map((goal, index) => (
                <div className="goal-card" key={index}>
                  <div className="goal-number">{goal.number}</div>
                  <h3>{goal.title}</h3>
                  <p>{goal.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      
      {/* Future Outlook */}
      {hasData('vision.future') && (
        <section className="section future-section">
          <div className="container">
            <div className="future-content">
              <div className="future-image">
                <img 
                  src={futureImage}
                  alt="Future Vision" 
                />
              </div>
              <div className="future-text">
                <h2>{getData('ui.vision.futureSection.title', 'Looking to the Future')}</h2>
                {futureParagraphs.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Vision; 